var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export default function MagicStarBig() {
    return (_jsx("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M7.72484 12.2743C6.4415 10.991 1.6665 10.4493 1.6665 9.99935C1.6665 9.54935 6.4415 9.00768 7.72484 7.72435C9.00817 6.44102 9.54984 1.66602 9.99984 1.66602C10.4498 1.66602 10.9915 6.44102 12.2748 7.72435C13.5582 9.00768 18.3332 9.54935 18.3332 9.99935C18.3332 10.4493 13.5582 10.991 12.2748 12.2743C10.9915 13.5577 10.4498 18.3327 9.99984 18.3327C9.54984 18.3327 9.00817 13.5577 7.72484 12.2743Z", fill: "#3E4D4D" }) })));
}
